export default __webpack_public_path__ + "static/media/musclerelax_caption.0248f008.jpeg";